<template>
  <div class="home">
    <Top />
    <div class="content">
      <Card1 id="card1" />
      <Card2 id="card2" />
      <Card3 />
      <Card4 id="card4" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from '../components/QuickMatrixTop.vue'
import Card1 from '../components/QuickMatrixCard1.vue'
import Card2 from '../components/QuickMatrixCard2.vue'
import Card3 from '../components/QuickMatrixCard3.vue'
import Card4 from '../components/QuickMatrixCard4.vue'
import Footer from '../components/QuickMatrixFooter.vue'

export default {
  name: 'HomePage',
  components: {
    Top,
    Card1,
    Card2,
    Card3,
    Card4,
    Footer,
  },
}
</script>

<style>
:root {
  --navbar-height: 60px;
  --footer-height: 53px;
  --card-min-height: calc(100vh - var(--navbar-height) - var(--footer-height));
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  overflow: hidden;
}

.home {
  display: grid;
  grid-template-rows: auto 1fr auto;
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

.content {
  scroll-snap-type: y mandatory;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.card {
  min-height: var(--card-min-height);
  scroll-snap-align: start;
  overflow: hidden;
}

.background {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  background: linear-gradient(180deg, #000000 .14%, #333333 99.88%);
  background-size: cover;
  min-height: var(--card-min-height);
  padding: 0;
  margin: 0;
}

.layout-tile {
  display: flex;
  flex-direction: row;
  border-radius: 24px;
  border: 2px solid #33333300;
  box-shadow: 0 4px 24px 0 rgba(71, 81, 135, .1);
  background: linear-gradient(180deg, rgba(46, 117, 255, .5), rgba(104, 155, 255, .5));
  padding: 24px;
  margin: 16px;
  max-width: 80%;
}

.layout-contents {
  display: flex;
  flex-direction: column;
}

.layout-title {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-size: 3.75rem;
  line-height: 4.25rem;
  font-weight: 700;
  color: #fff;
  font-family: Inter, "Noto Sans", "Segoe UI", Avenir, Helvetica, Arial, sans-serif;
}

.layout-desc {
  margin: 8px;
  font-size: 2rem;
  font-weight: 500;
  color: #eee;
  text-align: left;
}

.layout-img {
  max-width: 60%;
  height: auto;
  align-self: flex-start;
  object-fit: contain;
}

.download_btn {
  margin-top: 5%;
  font-size: 2.3rem;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  background: #3265f3;
  width: 370px;
  border: none;
  outline: none;
  padding: 10px 0;
}

.download_btn:hover {
  background: #2E75FF;
}

.platform-tip {
  margin: 8px 0 0;
  font-size: 0.95rem;
  color: #ddd;
  letter-spacing: 0.5px;
}

.platform-tip-mobile {
  display: none;
}

/* ====== 中小屏 / 平板 ====== */
@media (max-width: 1024px) {
  .layout-title {
    font-size: 2.5rem;
    line-height: 3rem;
  }
  .layout-desc {
    font-size: 1.4rem;
  }
  .layout-tile {
    max-width: 92%;
  }
}

/* ====== 移动端 ====== */
@media (max-width: 768px) {
  :root {
    --navbar-height: 56px;
    --footer-height: 44px;
  }

  body {
    overflow: auto;
  }

  .home {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .content {
    overflow-y: visible;
    scroll-snap-type: none;
  }

  .card {
    min-height: auto;
    overflow: visible;
  }

  .background {
    min-height: auto;
    padding: 24px 0;
  }

  .layout-tile {
    flex-direction: column !important;
    align-items: center;
    padding: 16px;
    margin: 12px;
    max-width: calc(100% - 24px);
    box-sizing: border-box;
  }

  .layout-img {
    max-width: 100% !important;
    width: 100%;
    align-self: center;
    margin-bottom: 12px;
  }

  .layout-title {
    font-size: 1.6rem;
    line-height: 2rem;
    margin: 8px 0;
    text-align: center;
  }

  .layout-desc {
    font-size: 1rem;
    margin: 6px 0;
    text-align: center;
  }

  .download_btn {
    width: 80%;
    max-width: 320px;
    font-size: 1.2rem;
    padding: 10px 0;
    margin-top: 24px;
  }

  .platform-tip {
    font-size: 0.85rem;
  }

  .platform-tip-mobile {
    display: block;
    color: #ffd2b2;
    font-weight: 500;
  }
}
</style>
